import React from 'react';
import PropTypes from 'prop-types';
import { PlusCircleFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';

export const AddButton = ({ title, onClick }) => {
  return (
    <Tooltip title={title}>
      <PlusCircleFilled className="create-icon blue-svg" onClick={onClick} />
    </Tooltip>
  );
};

AddButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
